module.exports = __webpack_public_path__ + "img/album14_16.2cbf10be.jpg";